import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function WhatIsThisDialog(props) {
  return (
    <Dialog open={props.open} onClose={props.onWhatIsThisDialogClosed} scroll="body">
      <DialogContent className="product-info-dialog-content">
        <IconButton className="product-info-close-button" aria-label="close" onClick={props.onWhatIsThisDialogClosed}>
          <CloseIcon />
        </IconButton>

        <h4>Manual Duties</h4>
        <p>You must specify the percentage of time you spend performing manual duties. All active duties performed in all occupations should be considered.</p>

        <p>
          Manual duties means any physical activity including, but not limited to: standing, walking, stooping, bending, pushing, pulling, lifting, carrying, climbing,
          crawling, kneeling and driving a vehicle.
          </p>
      </DialogContent>
    </Dialog>
  );
}

WhatIsThisDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onWhatIsThisDialogClosed: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/Quoters/Ameritas/Helpers/WhatIsThisDialog.js